import controller from './upload-classic-links.controller';
import template from './upload-classic-links.html';
import './upload-classic-links.scss';

export default {
	controller,
	template,
	bindings: {
		form:  '<',
		index: '<',
		links: '=ngModel',
	},
	require:  {
		block:       '^^uploadClassicBlock',
		ngModelCtrl: '?ngModel',
	},
};
